<template>
	<div>
		<div class="hidden-xs hidden-sm head_11">
			<div class="pc_header">
			<div class="top_top">
				<div class="wh">
					<!-- <span style="float: right;"><a href="#">中文 </a> | <a
							href="#">English</a></span> -->
							欢迎访问恒润集团官方网站</div>
			</div>
			<div class="wh flex_a" >
				<div class="logo_11" style="padding-left: 20px;">
					<a href="javascript:void(0)" @click="go('/')"><img alt="" src="../../html/images/logo.png" /></a>
				</div>

				<div class="nnav">
					<ul class="x-menu clearfix">
						<li>
							<a href="javascript:void(0)" @click="go('/')">首页</a>
						</li>
						<li v-for="item in configList">
							<a href="javascript:void(0)" @click="goOne(item)">{{item.categoryName}}</a>
							<ul class="x-sub-menu" v-if="item.children.length>0">
								<li><a href="javascript:void(0)"
										v-for="items in item.children" @click="goTwo(items)">{{items.categoryName}}</a></li>
							</ul>
						</li>
						
					</ul>
				</div>
				<div class="head_33 flex_a">
					<div class="dh" style="font-size: 24px; font-weight: bold; text-align: right; ;">
						<img src="../../html/images/tel.png" alt="" width="35px"
							style="margin-right: 20px;">400-636-1169
					</div>
				</div>
			</div>
			</div>
		</div>

		<!--pc_top-->
		<!--shoujitop-->
		<div class="xymob-head visible-sm visible-xs">
			<div class="xymob-head-box">
				<div class="xymob-logo">
					<div><a href="index.html"><img src="../../html/images/logo.png" /></a></div>
				</div>
				<div class="xymob-navbtn">
					<span></span>
				</div>

			</div>
			<div class="xymob-menu">
				<div class="xymob-menu-box">
					<ul class="xymob-nav">
						<li>
							<a href="javascript:void(0)" @click="go('/')">首页</a>
						</li>

						<li v-for="item in configList">
							<a href="javascript:void(0)">{{item.categoryName}}</a>

							<div class="xymob-menu-jt" @mouseover="enter(item)" @mouseleave="level(item)" style="cursor: pointer;"><i :class="item.categoryCode==selId?'icon-font icon-down':'icon-font'"></i></div>
							<ul class="xymob-sub-menu" v-if="item.children.length>0&&item.categoryCode==selId"  style="display: block;">
								<li v-for="items in item.children"><a
										href="javascript:void(0)" @click.stop="goTwo(items)">{{items.categoryName}}</a></li>
								<!-- <li><a href="02关于恒润 02 企业文化.html">企业文化</a></li>
								<li><a href="02关于恒润 03 发展历程.html">发展历程</a></li>
								<li><a href="02关于恒润 04 资质荣誉.html">资质荣誉</a></li> -->
							</ul>
						</li>
						<!-- <li>
							<a href="javascript:void(0)">集团动态</a>
		
							<div class="xymob-menu-jt"><i class="icon-font icon-down"></i></div>
							<ul class="xymob-sub-menu">
								<li><a href="03集团动态 01 新闻列表.html">政策解读</a></li>
								<li><a href="03集团动态 01 新闻列表.html">新闻中心</a></li>
							</ul>
						</li>
						<li>
							<a href="javascript:void(0)">业务范围</a>
		
							<div class="xymob-menu-jt"><i class="icon-font icon-down"></i></div>
							<ul class="xymob-sub-menu">
								<li><a href="04业务范围 01业务列表.html">水利市政</a></li>
								<li><a href="04业务范围 01业务列表.html">雷达天线</a></li>
								<li><a href="04业务范围 01业务列表.html">新能源</a></li>
								<li><a href="04业务范围 01业务列表.html">共享智造</a></li>
							</ul>
						</li>
						<li>
							<a href="javascript:void(0)">项目案例</a>
		
							<div class="xymob-menu-jt"><i class="icon-font icon-down"></i></div>
							<ul class="xymob-sub-menu">
								<li><a href="06项目案例 01案例列表.html">案例分类</a></li>
								<li><a href="06项目案例 01案例列表.html">案例分类</a></li>
								<li><a href="06项目案例 01案例列表.html">案例分类</a></li>
								<li><a href="006项目案例 01案例列表.html">案例分类</a></li>
							</ul>
						</li>
						<li>
							<a href="javascript:void(0)">社会责任</a>
		
							<div class="xymob-menu-jt"><i class="icon-font icon-down"></i></div>
							<ul class="xymob-sub-menu">
								<li><a href="07社会责任 01党建引领.html">党建引领</a></li>
								<li><a href="07社会责任 02责任担当.html">责任担当</a></li>
							</ul>
						</li>
						<li>
							<a href="javascript:void(0)">联系我们</a>
		
							<div class="xymob-menu-jt"><i class="icon-font icon-down"></i></div>
							<ul class="xymob-sub-menu">
								<li><a href="08联系我们 01人才招聘.html">人才招聘</a></li>
								<li><a href="08联系我们 02联系我们.html">联系我们</a></li>
							</ul>
						</li> -->

					</ul>

				</div>
			</div>

			<div class="xymob-search">
				<div class="xymob-search-close-btn"><i class="icon-font icon-close"></i></div>
				<div class="xymob-search-box">
					<form method="get" name="formsearch" id="formsearch" action="/search.php">
						<input type="text" name="wd" id="keyword" placeholder="请输入关键词" />
						<button type="submit" id="s_btn"><i class="icon-font"></i></button>
					</form>
				</div>
				<div class="xymob-seaerch-wz">
					<span>搜索</span>
					<a href=""></a>
				</div>
			</div>
		</div>
		<!--shoujitop-->

	</div>
</template>

<script>
	import {
		categorysortPage,
		articleList
	} from '@/api/reqFetch.js'
	import {
		clickToggle,
		backTop,
		placeholderSupport,
		iePlaceholder,
		antiClone
	} from '../../html/js/app_v.js'
	// import '../../html/js/main.js'
	export default {
		components: {},
		props: {

			sel: {
				type: String | Number,
				default: 1
			}

		},
		data() {
			return {
				showPhone: false,
				token: '',
				configList: [],
				title: '',
				selId: '',
				config: {
					homeUrl: '/',
					copyCode: "0",
					userName: ""
				}
			}
		},
		computed: {

		},
		mounted() {
			this.getCategorysortPage()
			var that=this
			

			// 获取本地文件夹名
			// 格式 /xypt/
			var localFileName = that.config.homeUrl.replace(window.location.origin, '');
			$(".x-menu a").each(function() {
				var AHref = $(this).attr('href');

				// 如果连接中不含有域名
				if (AHref.indexOf(that.config.homeUrl) === -1) {
					// 如果当前链接的第一个字符不是 '/'
					if (AHref.charCodeAt(0) !== 47) {
						AHref = '/' + AHref;
					}
					// 如果连接中不含有本地文件夹
					if (AHref.indexOf(localFileName) === -1) {
						// 路径就等于 配置相中的主域名+后台录入的地址
						AHref = that.config.homeUrl.substr(0, that.config.homeUrl.length - 1) + AHref;
					} else {
						// 否则 路径就等于 当前浏览器的origin+后台录入的地址
						AHref = window.location.origin + AHref;
					}
				}

				// 这个是路径一致的情况
				if (AHref === window.location.href) {
					$(".x-menu li").removeClass('active');
					// indexOf('x-sub-menu') 这里的 x-sub-menu 是下拉的元素类名，如果模板里改了类名这里也是要改的
					if ($(this).parent().parent().attr('class').indexOf('x-sub-menu') !== -1) {
						$(this).parent().parents('li').addClass('active')
					} else {
						$(this).parent().addClass('active')
					}
				}
			});



			//手机导航按钮点击效果
			clickToggle('.xymob-navbtn', '.xymob-menu');
			//导航条固定在头部
			if ($(window).scrollTop() > 30) {
				$('.xy-head').addClass('scroll');
			}
			$(window).scroll(function() {
				var len = $(this).scrollTop();
				if (len > 30) {
					$('.xy-head').addClass('scroll');
				} else {
					$('.xy-head').removeClass('scroll')
				}
			});

			//返回顶部
			backTop(".xymob-page-backtop", 300);

			// 搜索框判断
			$("input[name='wd']").each(function() {
				var _plac = $(this).attr('placeholder');
				$(this).focus(function() {
					$(this).attr('placeholder', '');
				});
				$(this).blur(function() {
					$(this).attr('placeholder', _plac);
				});
			});

			/* 内页共用js代码 */

			
			

			// 防复制代码
			if (that.config.copyCode == 1 && !(navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i))) {
				antiClone();
			}


		},
		methods: {
			clickToggle(elea, eleb) {
				$(elea).click(function() {
					if (!$(eleb).is(':visible')) {
						$(this).addClass('clicked');
						$(eleb).slideDown();
					} else {
						$(this).removeClass('clicked');
						$(eleb).slideUp();
					}
				})
			},
			changePhone() {
				this.showPhone = !this.showPhone
				this.$emit('changePhone', this.showPhone)
			},
			getCategorysortPage() {
				categorysortPage({
					pos: 'top'
				}).then(res => {
					res.data.map(item => {
						item.children.sort((a, b) => a.orderNum - b.orderNum);
					})
					this.configList = res.data
				});
			},

			changeTag(item) {
				this.selTag = item
			},
			go(url) {
				if (this.$route.fullPath != url) {
					this.$router.push(url)
					this.$router.go(0)
				}
			},
			enter(item) {
				
				if(item.categoryCode==this.selId){
					this.selId=''
				}else{
					this.selId = item.categoryCode
				}
			},
			goOne(item) {
				if(item.categoryName=='业务范围'){
					let url='/businessList1?type=' + item.categoryCode+'&title='+item.categoryName
				    this.go(url)
				}else if(item.categoryName=='项目案例'){
					let url='/caseOneList?type=' + item.categoryCode+'&title='+item.categoryName
				    this.go(url)
				}else if(item.categoryName=='科研创新'){
					let url='/societyOneList?type=' + item.categoryCode+'&title='+item.categoryName
				    this.go(url)
				}
				else{
					let url='/'+item.children[0].url+'?type=' + item.children[0].categoryCode+'&title='+item.children[0].categoryName
				    this.go(url)
				}
				
			},
			goTwo(item) {
				if (item.categoryName == '创新平台') {
					let url = '/society?type=' + item.categoryCode + '&title=' + item.categoryName
					this.go(url)
				} else if (item.categoryName == '人才团队'||item.categoryName=='检测试验中心'){
					let url=item.url+'&type='+item.categoryCode+'&title='+item.categoryName
					this.go(url)
				} else{
					let url='/'+item.url+'?type=' + item.categoryCode+'&title='+item.categoryName
				    this.go(url)
				}
				
			}
		}
	}
</script>